module.exports = __webpack_public_path__ + "fonts/trade-gothic-condensed-20.a6039aad.woff";